import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-recommendation-report-folder.controller';
import directive from './attach-recommendation-report-folder.directive';


export default angular.module('app.components.advisory.auditTrail.attachRecommendationReportFolder', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amAttachRecommendationReportFolder', directive)
  .controller('AttachRecommendationReportFolderController', controller)
  .name;

console.log('app.components.advisory.auditTrail.attachRecommendationReportFolder created');
